module.exports = __webpack_public_path__ + "static/facebookOSS-eca8c279040a489bd0d4cb882e717576.jpg";